module.exports = __webpack_public_path__ + "img/iletisim-kirmizi-cizgi.2e35c981.png";